import { InitiativeEditForm } from 'app/components/InitiativeEditForm';

const InitiativeEdit = () => {
  return <InitiativeEditForm />;
};

export default InitiativeEdit;
